import Loadable from 'UIComponents/decorators/Loadable';
const AsyncCollaborationSidebarDropArea = Loadable({
  loader: () => import(
  /* webpackChunkName: "collaboration-sidebar-drop-area" */
  './CollaborationSidebarDropArea').then(mod => mod.default),
  LoadingComponent: () => null,
  ErrorComponent: () => null
});
export default AsyncCollaborationSidebarDropArea;